import GetTagsByDataItemIdRequestModelBase from '../_generated/modelBases/get-tags-by-data-item-id-request-model-base';

export default class GetTagsByDataItemIdRequestModel extends GetTagsByDataItemIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
